// Centralized brand assets — swap CDN URLs here in one place.
// Both `appIcon` and `wordmark` are self-hosted in /public so ad blockers,
// privacy extensions, and strict corporate networks can't block them.
export const ASSETS = {
  appIcon: "/app-icon.png",
  wordmark: "/wordmark.png",
  heroBackground:
    "https://static.prod-images.emergentagent.com/jobs/299f4367-4c16-4c3e-bef0-717b4587514b/images/f294bee4450b074201a8fe4a699d363690af70a592d2b8161a1d2a347fb86e09.png",
  nurseHero:
    "https://customer-assets-agu9un31.emergentagent.net/job_stableish-landing/artifacts/o4uyooio_nurse%20looking.png",
  nursePhone:
    "https://static.prod-images.emergentagent.com/jobs/299f4367-4c16-4c3e-bef0-717b4587514b/images/049bc89475e31a8f1446254d175cd41491222b29413d880ae2eb8d213dcd0e37.png",
};

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// App Store — Stable-ish live listing (iOS)
export const APP_STORE_URL =
  "https://apps.apple.com/us/app/stable-ish/id6773289202";

// Google Play — leave as empty string until the Android version is published.
// When ready, paste the Play Store URL here and StoreBadges will
// automatically flip the button from "coming soon" → live.
export const GOOGLE_PLAY_URL = "";

// Social profiles
export const INSTAGRAM_URL = "https://instagram.com/_stableish";
export const FACEBOOK_URL =
  "https://www.facebook.com/profile.php?id=61592035943485";
// Fill in when a TikTok profile is live — /go will auto-show the button.
export const TIKTOK_URL = "https://www.tiktok.com/@_stableish";

// Apple App Store Connect — Campaign Attribution
// Once a campaign is created in App Store Connect → Analytics → Acquisition →
// Campaigns, paste the generated Provider Token here. Without it, `ct` params
// are ignored by Apple's Sources report. Until then, the code appends `ct`
// anyway so it "just works" once PROVIDER_TOKEN lands.
export const APP_STORE_PROVIDER_TOKEN = "128954095";

/**
 * Build an App Store URL with optional campaign attribution.
 * Apple format: ?pt=<providerToken>&ct=<campaign>&mt=8   (mt=8 = iOS App Store)
 * When PROVIDER_TOKEN is empty we still attach `ct` so our own analytics /
 * server-side logs can read it, and Apple silently ignores unknown params.
 */
export function buildAppStoreUrl(campaignToken) {
  if (!campaignToken) return APP_STORE_URL;
  const params = new URLSearchParams();
  if (APP_STORE_PROVIDER_TOKEN) params.set("pt", APP_STORE_PROVIDER_TOKEN);
  params.set("ct", campaignToken);
  params.set("mt", "8");
  return `${APP_STORE_URL}?${params.toString()}`;
}

/**
 * Detect iOS at runtime (client-side only).
 * Used by the /ig, /fb, /tw, etc. redirectors to switch to the itms-apps://
 * deep link scheme — which bypasses Instagram / Facebook / TikTok in-app
 * browsers that famously fail to hand off apps.apple.com HTTPS links.
 */
export function isIOS() {
  if (typeof navigator === "undefined") return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/**
 * Return the best App Store URL for this device.
 *  - iOS: itms-apps:// deep link — always hands off to the App Store app,
 *    even inside Instagram / Facebook / TikTok / X in-app browsers.
 *  - Other: standard https://apps.apple.com URL with `ct=` tracking.
 * The App Store app parses the `ct=` query in both cases, so campaign
 * attribution is preserved once APP_STORE_PROVIDER_TOKEN is filled in.
 */
export function getAppStoreDeepLink(campaignToken) {
  const webUrl = buildAppStoreUrl(campaignToken);
  if (isIOS()) {
    // Swap https:// → itms-apps:// for guaranteed in-app-browser handoff.
    return webUrl.replace(/^https:\/\//, "itms-apps://");
  }
  return webUrl;
}
